<section class="w-full border-b-2 border-primary-500 pb-10">

    @if(view.site?.id != 79) {
    <app-banner_section-type01 [options]="{ title: '', imageHref:view.imageLayer1 }"></app-banner_section-type01>
    }

    @if(view.page && view.site?.id === 79) {
    <!-- Header image with smooth flowing bottom -->
    <div class="relative w-screen h-[600px] overflow-hidden">
        <!-- Layer 1 -->
        <img [src]="view.imageLayer1" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 1" [class.opacity-100]="view.activeLayer === 1" />

        <!-- Layer 2 -->
        <img [src]="view.imageLayer2" alt="Slideshow Image"
            class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-1000"
            [class.opacity-0]="view.activeLayer !== 2" [class.opacity-100]="view.activeLayer === 2" />

        <!-- Flowing wave SVG cut -->
        <svg viewBox="0 0 1440 100" preserveAspectRatio="none" class="absolute bottom-0 left-0 w-full h-[80px] block">
            <path d="M0,0 C360,100 1080,0 1440,80 L1440,100 L0,100 Z" fill="white" />
        </svg>
    </div>
    }
    <!-- <app-banner_section-type01 [options]="{imageHref:view.imageHref}"></app-banner_section-type01> -->

    <section class="text-gray-600 bg-white body-font relative">
        <div class="container px-5 py-10 mx-auto flex sm:flex-nowrap flex-wrap">
            <div
                class="lg:w-2/3 md:w-1/2 bg-gray-300 rounded-lg overflow-hidden sm:mr-10 p-10 flex items-end justify-start relative">
                <div class="absolute inset-0 opacity-60">
                    <!-- <app-map-type01></app-map-type01> -->
                    @if(view.site?.id != 82 && view.site?.id != 150 && view.site?.id != 79 && view.site?.id != 86 && view.site?.id != 58) {
                    <app-map-type01 [zoom]="10" [disableUI]="true" [locations]="view.locations"
                        [defaultLat]="view.defaultLat" [defaultLng]="view.defaultLng"></app-map-type01>
                    }
                    @if(view.site?.id == 82) {
                    <app-map-type01 [zoom]="10" [disableUI]="true" [locations]="view.locations"
                        [defaultLat]="view.xlfswmLocation[0]?.lat || view.defaultLat"
                        [defaultLng]="view.xlfswmLocation[0]?.lng || view.defaultLng">
                    </app-map-type01>
                    }
                    @if(view.site?.id == 150) {
                    <app-map-type01 [zoom]="10" [disableUI]="true" [locations]="view.locations"
                        [defaultLat]="view.actLocation[0]?.lat || view.defaultLat"
                        [defaultLng]="view.actLocation[0]?.lng || view.defaultLng">
                    </app-map-type01>
                    }
                    @if(view.site?.id == 79) {
                    <app-map-type01 [zoom]="10" [disableUI]="true" [locations]="view.locations"
                        [defaultLat]="view.xlstLocation[0]?.lat || view.defaultLat"
                        [defaultLng]="view.xlstLocation[0]?.lng || view.defaultLng">
                    </app-map-type01>
                    }
                    @if(view.site?.id == 86) {
                    <app-map-type01 [zoom]="10" [disableUI]="true" [locations]="view.locations"
                        [defaultLat]="view.xlatLocation[0]?.lat || view.defaultLat"
                        [defaultLng]="view.xlatLocation[0]?.lng || view.defaultLng">
                    </app-map-type01>
                    }
                    @if(view.site?.id === 58) {
                    <app-map-type01 [zoom]="6" [disableUI]="true" [locations]="branchLocations"
                        [defaultLat]="defaultLat" [defaultLng]="defaultLng">
                    </app-map-type01>
                    }

                    <!-- <google-map height="100%" width="100%" [center]="{ lat:  view.defaultLat, lng: view.defaultLng }"
                        [zoom]="15">
                        <map-marker [position]="{  lat: view.defaultLat,  lng:  view.defaultLng  }">
                        </map-marker>
                    </google-map> -->
                </div>
                <div class="w-200 bg-white dark:bg-slate-900 relative flex flex-wrap py-6 rounded shadow-md">
                    @if(view.site?.address) {
                    <div class="lg:w-1/2 px-6">
                        <h2
                            class="title-font font-semibold text-gray-900 custom_font tracking-widest text-md uppercase dark:text-gray-100">
                            Address</h2>
                        <p>{{view.site.name}}</p>
                        <p class="mt-1">{{view.site.address}}</p>
                    </div>
                    }
                    <div class="lg:w-1/2 px-6 mt-4 lg:mt-0">
                        @if(view.site?.emailAddress) {
                        <h2
                            class="title-font font-semibold text-gray-900 custom_font tracking-widest text-md uppercase dark:text-gray-100">
                            Email</h2>
                            <div class="flex flex-col">
                                <a class="text-red-500 leading-relaxed">{{view.site?.emailAddress}}</a>
                                @if(view.site?.id === 74 || view.site?.id === 96) {
                                    <a class="text-green-800 leading-relaxed">penny.mcaslin&#64;optimavibe.co.za (rial)</a>
                                }
                            </div>
                        }
                        @if(view.site?.telephone) {
                        <h2
                            class="title-font font-semibold text-gray-900 custom_font tracking-widest text-md mt-4 uppercase dark:text-gray-100">
                            Phone</h2>
                        <p class="leading-relaxed">{{view.site?.telephone}}</p>
                        }
                    </div>
                </div>
            </div>
            <div
                class="lg:w-1/3 md:w-1/2 bg-white flex flex-col md:ml-auto w-full md:py-4 px-5 mt-8 md:mt-0 dark:bg-slate-800">
                <h2 class="text-primary-500 text-lg mb-1 pt-2 font-semibold title-font dark:text-gray-200">Reach Us</h2>
                <!-- <p class="leading-relaxed mb-5 text-gray-600">Post-ironic portland shabby chic echo park, banjo fashion axe</p> -->
                <div class="relative mb-4">
                    <label for="name" class="leading-7 text-sm text-gray-600 dark:text-gray-300">Name</label>
                    <input type="text" id="name" name="name" placeholder="First Name.."
                        class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 focus:border-red-500 focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                        [(ngModel)]="view.message.firstName">
                </div>
                <div class="relative mb-4">
                    <label for="email" class="leading-7 text-sm text-gray-600 dark:text-gray-300">Email</label>
                    <input type="email" id="email" name="email" placeholder="Email address..."
                        class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 focus:border-red-500 focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                        [(ngModel)]="view.message.emailAddress">
                </div>
                <div class="relative mb-4">
                    <label for="phone" class="leading-7 text-sm text-gray-600 dark:text-gray-300">Phone</label>
                    <input type="tel" id="phone" name="phone" placeholder="Phone Number..."
                        class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 focus:border-red-500 focus:ring-2 focus:ring-red-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                        [(ngModel)]="view.message.phoneNumber">
                </div>
                <div class="relative mb-4">
                    <label for="message" class="leading-7 text-sm text-gray-600 dark:text-gray-300">What Would You Like To Enquire About</label>
                    <textarea id="message" name="message" placeholder="Your message..."
                        class="w-full bg-white dark:bg-slate-900 rounded border border-gray-300 focus:border-red-500 focus:ring-2 focus:ring-red-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                        [(ngModel)]="view.message.comments"></textarea>
                </div>
                <div class="p-2">
                    <button [ngClass]="{ 'bg-accent-500 text-gray-500 cursor-not-allowed': !isFormValid(),
                    'bg-accent-500 text-primary-100 cursor-pointer hover:text-primary-500 hover:bg-primary-100 transition ease-out duration-500': isFormValid()
                    }" class="w-full rounded-xl uppercase font-semibold p-3 border-2 border-accent-500" type="submit"
                        (click)="sendMessage()">
                        {{isFormValid() ? 'Send Message Now' : 'Complete all fields'}}
                    </button>
                </div>
                <!-- <button class="text-white bg-red-500 border-0 py-2 px-6 focus:outline-none hover:bg-red-600 rounded text-lg">Button</button> -->
                <!-- <p class="text-xs text-gray-500 mt-3">Chicharrones blog helvetica normcore iceland tousled brook viral artisan.</p> -->
            </div>
        </div>
    </section>
    @if(view.site?.id === 58) {
    <app-branch-selector [provinces]="provinces" class="py-10"></app-branch-selector>
    }
</section>